import { C, SANS } from "./theme";
import { gbp } from "./reportUtils";

export default function MonthlyChart({ rows, height = 200 }) {
  const maxGross = Math.max(...rows.map((r) => r.gross), 1);
  const niceMax = Math.ceil(maxGross / 500) * 500;
  const peakNet = Math.max(...rows.map((r) => r.net));
  const quietNet = Math.min(...rows.map((r) => r.net));
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((f) => Math.round(niceMax * f));

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex" }}>
        {/* Y axis labels */}
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height, width: 40, paddingBottom: 2 }}>
          {ticks.slice().reverse().map((t, i) => (
            <span key={i} style={{ fontFamily: SANS, fontSize: 9, color: C.faint, textAlign: "right", paddingRight: 8 }}>
              £{(t / 1000).toFixed(t % 1000 ? 1 : 0)}k
            </span>
          ))}
        </div>
        {/* Bars */}
        <div style={{ flex: 1, display: "flex", alignItems: "flex-end", height, borderBottom: `1px solid ${C.evergreen}`, gap: 6 }}>
          {rows.map((r, i) => {
            const netH = (r.net / niceMax) * height;
            const feesH = ((r.gross - r.net) / niceMax) * height;
            const isMark = r.net === peakNet || r.net === quietNet;
            return (
              <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", height, position: "relative" }}>
                {isMark && (
                  <div style={{ position: "absolute", bottom: Math.max(feesH + netH, 1) + 4, left: 0, right: 0, textAlign: "center", fontFamily: SANS, fontSize: 9, fontWeight: 600, color: C.evergreen, whiteSpace: "nowrap", lineHeight: 1.2, zIndex: 10 }}>
                    {gbp(r.net)}
                  </div>
                )}
                <div style={{ width: "62%", background: C.peach, height: Math.max(feesH, 1), borderRadius: "4px 4px 0 0" }} />
                <div style={{ width: "62%", background: C.evergreen, height: Math.max(netH, 1) }} />
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, marginTop: 6, paddingLeft: 40 }}>
        {rows.map((r, i) => (
          <div key={i} style={{ flex: 1, textAlign: "center", fontFamily: SANS, fontSize: 9, color: C.muted }}>{r.month}</div>
        ))}
      </div>
    </div>
  );
}